(function(){
  'use strict';
  var observer;
  function removeUrgency(){
    document.querySelectorAll('[data-pk-offer-urgency]').forEach(function(section){section.remove();});
  }
  function start(){
    removeUrgency();
    if(!window.MutationObserver||observer)return;
    observer=new MutationObserver(removeUrgency);
    observer.observe(document.documentElement,{childList:true,subtree:true});
    window.setTimeout(removeUrgency,550);
    window.setTimeout(removeUrgency,1200);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
  document.addEventListener('shopify:section:load',function(){window.setTimeout(removeUrgency,20);});
})();
